const slug = (label: string): string =>
  label.toLowerCase().replace(/\s+/g, '-');

export const topNavTestIds = {
  // Brand / logo
  brandLink: 'topnav-brand-link',

  // Desktop primary nav links (Home, Integrations, Activity, Settings)
  link: (label: string) => `topnav-${slug(label)}-link` as const,

  // Mobile primary nav links (same items, separate DOM in the mobile menu)
  mobileLink: (label: string) => `topnav-mobile-${slug(label)}-link` as const,

  // Account switcher
  accountSwitcherButton: 'topnav-account-switcher-button',
  accountSwitcherMenu: 'topnav-account-switcher-menu',
  accountSwitcherOption: (orgId: string) =>
    `topnav-account-switcher-option-${orgId}` as const,
  accountSwitcherSearchInput: 'topnav-account-switcher-search-input',
  accountSwitcherList: 'topnav-account-switcher-list',
  // Only rendered on the row being switched to, so its presence is also the
  // assertion that the switch is showing progress somewhere.
  accountSwitcherSpinner: 'topnav-account-switcher-spinner',
  accountSwitcherEmpty: 'topnav-account-switcher-empty',
  accountSwitcherOverlay: 'topnav-account-switcher-overlay',
  accountMenuIdentity: 'topnav-account-menu-identity',
  accountSignOutButton: 'topnav-account-sign-out-button',

  // Admin console link (platform_admin only)

  // Theme toggle
  themeToggleButton: 'topnav-theme-toggle-button',
  docsLink: 'topnav-docs-link',

  // Profile dropdown
  profileDropdownButton: 'topnav-profile-dropdown-button',
  profileMenu: 'topnav-profile-menu',
  profileMenuProfileLink: 'topnav-profile-menu-profile-link',
  profileMenuSettingsLink: 'topnav-profile-menu-settings-link',
  profileMenuSignOutButton: 'topnav-profile-menu-sign-out-button',

  // Mobile menu
  mobileToggleButton: 'topnav-mobile-toggle-button',
  mobileMenu: 'topnav-mobile-menu',
  mobileScrim: 'topnav-mobile-scrim',
  mobileProfileLink: 'topnav-mobile-profile-link',
  mobileSignOutButton: 'topnav-mobile-sign-out-button',
} as const;
